import * as React from "react";
import * as PropTypes from "prop-types";
const css = require("./hockeyapp-badge.scss");
const hockeyappLogo = require("./hockeyapp-logo.svg");

interface HockeyappBadgeProps {
  // Nothing to add here yet.
}

export class HockeyappBadge extends React.Component<HockeyappBadgeProps, {}> {
  public static propTypes: React.ValidationMap<HockeyappBadgeProps> = {
    children: PropTypes.element
  };

  public render() {
    return (
      <div className={css.wrapper}>
        <img alt="" role="presentation" src={hockeyappLogo} />
        {this.props.children}
      </div>
    );
  }
}
